import { Notification } from "./alerts";
import { Environment, UserInfo } from "./statics";
var API = /** @class */ (function () {
    function API() {
    }
    API.get = function (apiCall, func) {
        if (API.uri != "") {
            $.getJSON(API.uri + apiCall, function (result) {
                func(result);
            });
        }
    };
    API.getAjaxJSON = function (target, success) {
        $.ajax({
            url: API.uri + target + "?ssid=" + Environment.ssid,
            method: "GET",
            success: function (result) { return success(result); },
            dataType: "json"
        });
    };
    API.getData = function (target, success, fail) {
        if (Array.isArray(target)) {
            new getDataByArray(target, success, fail);
            return;
        }
        if (API.uri != "") {
            $.getJSON(API.uri + target + "?ssid=" + Environment.ssid, function (result) {
                if (result.has_data) {
                    success(result.data, result);
                    return;
                }
                if (fail) {
                    fail(result.messages);
                }
                else {
                    console.log(result.messages);
                }
            }).fail(function (e) {
                console.log(e);
            });
        }
    };
    API.parseMessages = function (m) {
        m = JSON.parse(m);
        if (m.messages.length > 0) {
            m.messages.forEach(function (_t) {
                var style = "";
                var time = 750;
                switch (_t.type) {
                    case 1:
                        style = "";
                        break;
                    case 2:
                        style = "info-notice";
                        break;
                    case 3:
                        style = "error-notice";
                        time = 2500;
                        break;
                    case 4:
                        style = "success-notice";
                        break;
                }
                Notification.show(_t.text, "", style, time);
            });
        }
        else {
            Notification.show("Es gab keine Nachricht vom Server...", "", "");
            console.log(m);
        }
    };
    API.insertData = function (target, data, fail, onDone) {
        var _this = this;
        var json = JSON.stringify({
            cmd: "insert",
            target_id: "",
            uuid: UserInfo.uuid,
            data: data
        });
        $.post(API.uri + target + "?ssid=" + Environment.ssid, { set: json })
            .done(function (m) {
            _this.parseMessages(m);
            if (onDone != undefined)
                onDone();
        })
            .fail(function (m) {
            if (fail != undefined)
                fail(m);
            else {
                console.log(m);
            }
        });
    };
    API.deleteData = function (target, id, fail, onDone) {
        var _this = this;
        var json = JSON.stringify({
            cmd: "delete",
            target_id: id,
            uuid: UserInfo.uuid,
            data: []
        });
        $.post(API.uri + target + "?ssid=" + Environment.ssid, { set: json })
            .done(function (m) {
            _this.parseMessages(m);
            if (onDone != undefined)
                onDone();
        })
            .fail(function (m) {
            if (fail != undefined)
                fail(m);
            else {
                console.log(m);
            }
        });
    };
    API.updateData = function (target, id, data, fail, onDone) {
        var _this = this;
        var json = JSON.stringify({
            cmd: "update",
            target_id: id,
            uuid: UserInfo.uuid,
            data: data
        });
        $.post(API.uri + target + "?ssid=" + Environment.ssid, { set: json })
            .done(function (m) {
            _this.parseMessages(m);
            if (onDone != undefined)
                onDone();
        })
            .fail(function (m) {
            if (fail != undefined)
                fail(m);
            else {
                console.log(m);
            }
        });
    };
    API.postData = function (target, cmd, id, data, onDone, silent, fail) {
        var _this = this;
        if (silent === void 0) { silent = false; }
        var json = JSON.stringify({
            cmd: cmd,
            target_id: id,
            uuid: UserInfo.uuid,
            data: data
        });
        $.post(API.uri + target + "?ssid=" + Environment.ssid, { set: json })
            .done(function (m) {
            if (!silent)
                _this.parseMessages(m);
            if (onDone != undefined)
                onDone(JSON.parse(m));
        })
            .fail(function (m) {
            if (fail != undefined)
                fail(m);
            else {
                console.log(m);
            }
        });
    };
    API.uri = "";
    return API;
}());
export { API };
var getDataByArray = /** @class */ (function () {
    function getDataByArray(call, success, fail) {
        this.result = [];
        this.call = call;
        this.success = success;
        this.fail = fail;
        this.perform();
    }
    getDataByArray.prototype.perform = function () {
        var _this = this;
        var current = this.call.shift();
        $.getJSON(API.uri + current + "?ssid=" + Environment.ssid, function (result) {
            if (result.has_data) {
                var k = Object.keys(result.data);
                for (var i = 0; i < k.length; i++)
                    _this.result[k[i]] = result.data[k[i]];
                if (_this.call.length > 0)
                    _this.perform();
                else
                    _this.success(_this.result);
                return;
            }
            _this.fail(result.messages);
            return;
        });
    };
    return getDataByArray;
}());
